'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(CtaStyle2) {
  CtaStyle2["OPTIN"] = "optin";
  CtaStyle2["LINK"] = "link";
  CtaStyle2["BLUE"] = "blue";
  CtaStyle2["GREEN"] = "green";
  CtaStyle2["GREY"] = "grey";
  CtaStyle2["ORANGE"] = "orange";
})(exports.CtaStyle || (exports.CtaStyle = {}));
(function(CtaTarget2) {
  CtaTarget2["SELF"] = "_self";
  CtaTarget2["NEW_TAB"] = "_blank";
  CtaTarget2["PARENT"] = "_parent";
  CtaTarget2["TOP"] = "_top";
})(exports.CtaTarget || (exports.CtaTarget = {}));
